module.exports = __webpack_public_path__ + "static/media/s1.03d9a051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s1.jpg
// module id = 110
// module chunks = 0